import React, { ReactElement } from "react";
import Layout from "../../components/layout";
import EmailNotification from "../../components/Notification/email";

const EmailNotificationPage = (): ReactElement => {
  return (
    <Layout>
      <EmailNotification />
    </Layout>
  );
};

export default EmailNotificationPage;
